import { ajax } from "rxjs/ajax";
import { stringify } from "querystringify";

import { ENV } from "../constants/env";
class Api {
    /**
     * getUrl
     * * Retorna el hostserver  concatenated with the custom url
     * ? All class have to extends from Api
     * @param url this param is the url to concatenated
     * @param host this param is optional for custom hostserver
     */

    static authorization = "";

    static getUrl(url, host) {
        return `${host}/${url}`;
    }
    static getHeader({ data } = {}) {
        const headers = {};
        if (!!data) {
            if (!(data instanceof FormData)) {
                headers["Content-Type"] = "application/json";
            }
        }
        return headers;
    }
    static getPrivateHeader({ data } = {}) {
        const headers = { Authorization: Api.authorization };
        if (!!data) {
            if (!(data instanceof FormData)) {
                headers["Content-Type"] = "application/json";
            }
        }
        return headers;
    }
    static getJSON(
        url,
        {
            params = {},
            isPublicRequest = true,
            host = ENV.BACKEND_URL,
            customHeader = null,
        }
    ) {
        return ajax.getJSON(
            Api.getUrl(`${url}?${stringify(params)}`, host),
            customHeader
                ? customHeader
                : isPublicRequest
                ? Api.getHeader()
                : Api.getPrivateHeader()
        );
    }
    static get(
        url,
        {
            params = {},
            isPublicRequest = true,
            host = ENV.BACKEND_URL,
            customHeader = null,
        } = {}
    ) {
        return ajax.get(
            Api.getUrl(`${url}?${stringify(params)}`, host),
            customHeader
                ? customHeader
                : isPublicRequest
                ? Api.getHeader()
                : Api.getPrivateHeader({ data: {} })
        );
    }
    static post(
        url,
        {
            params = {},
            data = {},
            isPublicRequest = true,
            host = ENV.BACKEND_URL,
            customHeader = {},
        }
    ) {
        return ajax.post(Api.getUrl(`${url}?${stringify(params)}`, host), data, {
            ...(isPublicRequest
                ? Api.getHeader({ data })
                : Api.getPrivateHeader({ data })),
            ...customHeader,
        });
    }
    static put(
        url,
        {
            params = {},
            isPublicRequest = true,
            host = ENV.BACKEND_URL,
            customHeader = null,
        }
    ) {
        return ajax.put(
            Api.getUrl(url, host),
            params,
            customHeader
                ? customHeader
                : isPublicRequest
                ? Api.getHeader()
                : Api.getPrivateHeader()
        );
    }

    static patch(
        url,
        {
            params = {},
            data = {},
            isPublicRequest = true,
            host = ENV.BACKEND_URL,
            customHeader = null,
        }
    ) {
        return ajax.patch(
            Api.getUrl(`${url}?${stringify(params)}`, host),
            data,
            customHeader
                ? customHeader
                : isPublicRequest
                ? Api.getHeader({ data })
                : Api.getPrivateHeader({ data })
        );
    }
    static delete(
        url,
        {
            params = {},
            isPublicRequest = true,
            host = ENV.BACKEND_URL,
            customHeader = null,
        }
    ) {
        return ajax.delete(
            Api.getUrl(url, host),
            customHeader
                ? customHeader
                : isPublicRequest
                ? Api.getHeader()
                : Api.getPrivateHeader()
        );
    }
}
export default Api;
